export default {
	FIRST_RUN_INTRO (state, val) {
		state.intro = typeof val === 'boolean' ? val : false
		if (!state.intro) state.pronounceActive = true
	},
	FIRST_RUN_ABOUT_HUKOS (state, val) {
		state.aboutHukos = typeof val === 'boolean' ? val : false
	},
	SET_PRONOUNCE_FLAG (state, val) {
		state.pronounceActive = typeof val === 'boolean' ? val : true
	}
}
